import React from 'react';
import {InputGroup, FormControl} from 'react-bootstrap';

export default function SearchInput({handleChange}) {
  return (
    <InputGroup className="mb-3">
    <FormControl
      placeholder="חיפוש"
      aria-label="search"
      aria-describedby="basic-addon1"
      onChange={(e) => handleChange(e.target.value)}
    />
    <InputGroup.Append>
      <InputGroup.Text id="basic-addon1">@</InputGroup.Text>
    </InputGroup.Append>
  </InputGroup>
  )
}